/**
* 底部菜单
*/ 
<template>
  <!-- 底部2 -->
  <footer class="footer w1200" id="footer2" ref="footer">
    <div class="footermenu">
      <div class="footermenulist">
        <ul v-for="item in ulTittel" :key="item.id">
          {{item.name}}
          <li v-for="(linkItem,index) in item.link" :key="index">
            <router-link :to="linkItem.url">{{linkItem.urln}}</router-link>
          </li>
         
        </ul>
      </div>
    </div>
    <div class="footer_menu clearfix">
      <div class="clearfix">
        <!-- <p>浙江正泰睿能能源服务有限公司</p> -->
        <!-- <div class="fl">
          <dl v-for="(item,index) in leftMenu" :key='index'>
            <dt>{{item.categoryName}}</dt>
            <dd v-for="(titleItem,indexs) in item.helpArticleList" :key="indexs">
              <li>
                <router-link :to="`siteHelpDetail?itemId=${titleItem.articleId}`"
                >
                  <div class="OneLineDisplay" :title="titleItem.articleTitle">{{titleItem.articleTitle}}</div></router-link>
              </li>            
            </dd>
          </dl>
          
        </div> -->
        <div class="fr" style="display: none">
          <!-- <div class="footer_logo">
            <img
              src="//xunyoutest.com/shop/static/src/default/images/index/footlogo.png"
            />
          </div>
          <div class="shop_code">
            <div class="footer_wx fr">
              <img
                src="//xunyoutest.com/shop/static/src/default/images/index/footwx.png"
              />
            </div>
            <div class="footer_wap fr">
              <img
                src="//xunyoutest.com/shop/static/src/default/images/index/footwap.png"
              />
            </div> -->
          <!-- </div> -->
        </div>
      </div>

      <div class="copyright_pc">
        <p>
          <!-- {{informations.copyrightInformation}} <br /> -->
          浙江正泰智维能源服务有限公司<br/>
          
        </p>
        <div class="copyright_pcout">
          
          <a class="copyright_pcTitle" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33010802011728" target="_blank" style="color:#939393;"
            ><img :src="`${$imageUrl}/pcImages/ztimg/safety.png`" style="width:20px;height:20px;margin-bottom:4px;" alt="">浙公网安备 33010802011728号</a
          >
          <a class="copyright_pcTitle" style="color:#939393;" href="https://beian.miit.gov.cn/#/Integrated/recordQuery" target="_blank"
            >
            <!-- {{informations.icp}} -->
            浙ICP备2021039685号<span v-if="envNODE_ENV === 'test'">-1</span><span v-if="envNODE_ENV === 'production'">-2</span>
            
            </a
          >
          <a class="copyright_pcTitle" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33010802011728" target="_blank" style="color:#939393;"
            >经营许可证编号 浙B2<span class="outSpan"><span>-</span></span>20230032-</a
          >
          
        </div>
        <!--<p><a href="http://webscan.360.cn/index/checkwebsite/url/www.xunyoutest.com"><img border="0" src="http://webscan.360.cn/status/pai/hash/9c7d033758c4f753bc19ee404a1adb4c"/></a></p>-->
      </div>
    </div>
  </footer>
</template>
<script>
import { menu } from "../api/userMG";
import {helpArticle_list,article_category_list,copyRight,bottom_article_list} from '@/api/xunyou'
export default {
  name: "leftnav",
  data() {
    return {
      collapsed: false,
      allmenu: [],
      leftMenu:[],  
      informations:{} ,  
      ulTittel:[
        {id:1, name:'服务指南',link:[
          {urln:"常见问题",url:"/commonproblem"},
          {urln:"发票流程",url:"/invoice"},
          {urln:"下单说明",url:"/orderdescription"}
        ]},
        {id:2, name:'配送方式',link:[
          {urln:"配送说明",url:"delivery"},
        ]},
        {id:3, name:'支付方式',link:[
          {urln:"支付说明",url:"payment"},
        ]},
        {id:4, name:'售后服务',link:[
          {urln:"退换货流程",url:"exchange"},
          // {urln:"退换货流程",url:"exchange"}
          {urln:"联系售后",url:"aftersale"},
        ]},
        // {id:5, name:'售后服务',link:[
        //   {urln:"联系售后",url:"aftersale"},
        // ]},
        {id:6, name:'关于云赢',link:[
          {urln:"云赢介绍",url:"briefintroduction"},
          {urln:"联系我们",url:"contactus"}
        ]},
      ],
      envNODE_ENV:'',
    };
  },
  // 创建完毕状态(里面是操作)
  created() {
   //this.getHelpArticle_list()
   this.getArticleList()
   this.geTCopyright()
   this.envNODE_ENV = process.env.NODE_ENV
  },
  methods:{
    getScroll() {
      // 滚动条距离底部的距离scrollBottom
      let scrollBottom =
        $event.target.scrollHeight -
        $event.target.scrollTop -
        $event.target.clientHeight;
      // if (this.finished && scrollBottom < 40) {
      //  操作
      // }
      console.log(scrollBottom)
    },
    // 获取版权名称
    geTCopyright(){
      copyRight().then(res=>{
        // console.log(res)
        // console.log( $event.target.clientHeight)
        if(res.code==0){
          this.informations = res.rows[0]
          console.log(this.informations)
        }
      }).catch(err=>{
        this.$message.error('查询失败,请稍后再试!')
      })
    },
    // 文章分类列表   
        getArticleList(){
            bottom_article_list()
                .then(res => {
                if (res.code == 0) {
                    this.leftMenu = res.rows.slice(0,5);
                    
                } else {
                    this.$message({
                    type: 'info',
                    message: res.msg
                    })
                }
                })
                .catch(err => {
                this.editFormVisible = false
                this.loading = false
                this.$message.error('获取列表失败，请稍后再试！')
                })
        },
        // 文章（和公告）列表接口   
        getHelpArticle_list(){
            helpArticle_list()
                .then(res => {
                if (res.code == 0) {
                    this.allmenu =res.rows;
                    // if(res.rows.length>0){
                        
                    // const s = new Set() //实例化对象
                    // console.log(s,'封装数据------------')

                    // res.rows.forEach(item => s.add(item.categoryId)) //添加值（Set可以去掉重复数据）

                    // let newData = Array.from({ length: s.size }, () => []) //创建指定长度数组并添值

                    // res.rows.forEach(item => {

                    //     let index = [...s].indexOf(item.categoryId) //找到指定下标

                    //     newData[index].push(item) //添加数据

                    // })
                    // this.allmenu = newData
                    //   console.log(this.allmenu,'封装数据------------')
                    // }
                } else {
                    this.$message({
                    type: 'info',
                    message: res.msg
                    })
                }
                })
                .catch(err => {
                // this.loading = false
                this.$message.error('获取文章列表失败，请稍后再试！')
                })
        },
        
        getfoodnavY(){
          var foodnavY = this.$refs.footer.offsetHeight
          this.$store.commit('getfoodnavY',foodnavY)
        }
  },
  mounted(){
    this.getfoodnavY()
  }
};
</script>
 <style scoped lang='less'>
.footer_menu{
  position: relative;
}
.footer .footer_menu dl{
  width: 200px;
  margin:15px
}
.footer .footer_menu dl dt{
  text-align: left;
}
.footer .footer_menu dl dd{
     text-align: left;
  }
.copyright_pc{
  position: revert;
  text-align: center;
  margin: 10px 0;
  color: #D9D9D9;
  font-size: 16px;
  .copyright_pcout{
    display: flex;
    justify-content: center;
    .copyright_pcTitle{
      margin: 0 10px;
      .outSpan{
        position: relative;
        display: inline-block;
        width: 5px;
        span{
          position: absolute;
          top: -19px;
          left: 0;
        }
      }
  }
  }
  
}


.footermenu{
  display: flex;
  justify-content: center;
  .footermenulist{
    display: flex;
    justify-content: space-between;
    ul{
      padding: 20px;
      color: #D9D9D9;
      font-size: 16px;
      text-align: center;
      li{
        padding: 8px 30px;
        font-size: 14px;
      }
    }
  }
}
/deep/.el-footer{
  background: #1A1A1C;
}
.footer{
  margin-top: 0;
}
.footer .footer_menu{
  padding-top: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/footernav.vue